import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/App.css';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Register service worker with update callback
serviceWorkerRegistration.register({
  onUpdate: (registration) => {
    // Call the global callback set by App.js
    if (window.onUpdateAvailable) {
      window.onUpdateAvailable(registration);
    }
  },
});
